import axios from "axios";
import { useAuthStore } from "@/stores/auth-store";

const baseURL = import.meta.env.VITE_API_URL ?? "http://localhost:3001";

/** Axios instance — injects the admin bearer token; logs out + redirects on 401. */
export const apiClient = axios.create({ baseURL });

apiClient.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

apiClient.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().logout();
      if (window.location.pathname !== "/login") {
        window.location.assign("/login");
      }
    }
    return Promise.reject(error);
  }
);
